<template>
    <section id="price-tier-section">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 img-pricing-section">
                    <h2>Standard pricing for
                        <nobr>royalty-free</nobr>
                        image license
                    </h2>
                    <div class="sub-heading">
                        Pricing excludes GST. <br class="d-block d-sm-none">Read Content License Agreement
                        <a :href="$router.resolve({ name: 'content-licence-agreement' }).href" @click.prevent="$bvModal.show('content-licence-agreement-modal')">here</a>.
                    </div>
                    <div class="row">
                        <div v-for="price in getDefaultPrices('image')" :key="price.id" class="col-6 col-md-3">
                            <div class="price-name-amount"><strong>{{ price.size }}</strong>{{ moneyOptionalDecimal(parseFloat(price.amount)) }}</div>
                            <div class="price-dimensions">{{ dimensions[price.size].length }} {{ dimensions[price.size].dpi }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                    <h2 class="mb-0">Video licenses. Two pricing tiers based on usage.</h2>
                    <div class="row">
                        <div class="col-12 col-md-6 pt-5">
                            <div class="licence-name">{{ getLicenceName('video', 0, 0) }}</div>
                            <b-dropdown menu-class="w-100" toggle-class="video-dropdown">
                                <template #button-content>
                                    <div v-html="getPriceText('video', 0, 0, '720p')"/>
                                </template>
                                <b-dropdown-item v-for="price in getPrices('video', 0, 0)" :key="price.id" v-html="price"/>
                            </b-dropdown>
                        </div>
                        <div class="col-12 col-md-6 pt-5">
                            <div class="licence-name">{{ getLicenceName('video', 1, 0) }}</div>
                            <b-dropdown menu-class="w-100" toggle-class="video-dropdown">
                                <template #button-content>
                                    <div v-html="getPriceText('video', 1, 0, '1080p')"/>
                                </template>
                                <b-dropdown-item v-for="price in getPrices('video', 1, 0)" :key="price.id" v-html="price"/>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'NzPricing',
    props: {
        prices: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            dimensions: {
                xs: {
                    length: '600px',
                    dpi: '72dpi'
                },
                s: {
                    length: '850px',
                    dpi: '72dpi'
                },
                m: {
                    length: '1,600px',
                    dpi: '72dpi'
                },
                l: {
                    length: '22cm',
                    dpi: '300dpi'
                },
                xl: {
                    length: 'At least 42cm',
                    dpi: '300dpi'
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            licences: 'data/licences'
        })
    },
    methods: {
        getDefaultPrices (type) {
            const defaultLicence = this.licences[type].find(licence => licence.default === 1)
            const defaultPriceTier = defaultLicence.tiers.find(tier => tier.default === 1)

            return this.prices.filter(price => price.default === 1 &&
                price.stock_licence_id === defaultLicence.id &&
                price.stock_price_tier_id === defaultPriceTier.id &&
                price.amount !== null
            )
        },
        getPrices (type, licenceIndex, priceTier) {
            const prices = this.licences[type][licenceIndex].tiers[priceTier].prices
            const html = []

            for (const price of prices) {
                if (price.amount) {
                    html.push(this.getPriceHtml(type, price, true))
                }
            }

            return html
        },
        getPriceText (type, licenceIndex, priceTier, size) {
            const price = this.licences[type][licenceIndex].tiers[priceTier].prices.find(price => price.size === size)

            return this.getPriceHtml(type, price, false)
        },
        getLicenceName (type, licenceIndex) {
            return this.licences[type][licenceIndex].name
        },
        getPriceHtml (type, price, wrap) {
            let html = ''

            if (type === 'image') {
                html = `<div class="big left">${price.size}</div><div class="small">${this.dimensions[price.size].length}px (${this.dimensions[price.size].dpi}dpi)</div><div class="big right">${this.moneyOptionalDecimal(parseFloat(price.amount))}</div>`
            } else {
                html = `<div class="big left">${price.size}</div><div class="big">-</div><div class="big right">${this.moneyOptionalDecimal(parseFloat(price.amount))}</div>`
            }

            if (wrap) {
                html = `<a role="menuitem" href="#" target="_self" class="dropdown-item">${html}</a>`
            }

            return html
        }
    }
}
</script>
